import { useCallback, useContext, type MouseEvent } from 'react';
import { ScrollContext, type ScrollContextValue } from './scroll-provider';

export function useScroll(): ScrollContextValue {
  const ctx = useContext(ScrollContext);
  if (!ctx) throw new Error('useScroll must be used inside <ScrollProvider>');
  return ctx;
}

export interface SectionLinkProps {
  href: string;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * Props for an anchor that scrolls smoothly to a section: a real `#id` href (right-click,
 * middle-click and assistive tech keep working) whose click Lenis takes over.
 */
export function useSectionLink(): (id: string) => SectionLinkProps {
  const { scrollToSection } = useScroll();
  return useCallback(
    (id: string) => ({
      href: `#${id}`,
      onClick: (event: MouseEvent<HTMLAnchorElement>) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        scrollToSection(id);
      },
    }),
    [scrollToSection],
  );
}
